import { render } from "./TextInputUpper.vue?vue&type=template&id=47d5b543"
import script from "./TextInputUpper.vue?vue&type=script&lang=js"
export * from "./TextInputUpper.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/mwon.net/gugar.mwon.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__